(function () {
  var TARGETS = ['rolled', 'sheet', 'tile'];

  function scrollToBanner(key) {
    var el = document.querySelector('.htu__banner--' + key);
    if (!el) return false;
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var key = a.getAttribute('href').slice(1);
    if (TARGETS.indexOf(key) === -1) return;
    if (scrollToBanner(key)) {
      e.preventDefault();
      history.replaceState(null, '', '#' + key);
    }
  });

  function scrollFromHash(delay) {
    var key = window.location.hash.slice(1);
    if (TARGETS.indexOf(key) === -1) return;
    setTimeout(function () { scrollToBanner(key); }, delay || 0);
  }

  if (window.location.hash) {
    // Wait for images to lay out so scroll target lands correctly
    if (document.readyState === 'complete') {
      scrollFromHash(50);
    } else {
      window.addEventListener('load', function () { scrollFromHash(50); });
    }
  }

  window.addEventListener('hashchange', function () { scrollFromHash(0); });
})();
